import { useTranslation } from 'react-i18next'

import { CalendarDayIcon } from '@pleio/icons/calendar-day'

import DropdownButton from 'js/components/DropdownButton'
import IconButton from 'js/components/IconButton'
import type { SiteStoreState } from 'js/lib/stores/SiteStore'

import type { EventItemViewFragment } from '../../EventPage/EventItemView.fragment.generated'

import useAddToCalendar from './useAddToCalendar'

export type AddToCalendarEntity = Pick<
    EventItemViewFragment,
    'title' | 'startDate'
> &
    Partial<
        Pick<
            EventItemViewFragment,
            | 'excerpt'
            | 'endDate'
            | 'location'
            | 'locationAddress'
            | 'locationLink'
            | 'videoCallUrl'
        >
    >

export type AddToCalendarSite = Partial<
    Pick<SiteStoreState['site'], 'integratedVideocallEnabled'>
>

export type AddToCalendarProps = {
    entity: AddToCalendarEntity
    site: AddToCalendarSite
}

const AddToCalendar = ({ entity, site }: AddToCalendarProps) => {
    const { t } = useTranslation()

    const { options } = useAddToCalendar({ entity, site, window, navigator })

    return (
        <DropdownButton
            options={options}
            side="bottom"
            align="center"
            className="EventAction"
        >
            <IconButton
                variant="primary"
                radiusStyle="rounded"
                className="EventActionButton"
            >
                <CalendarDayIcon />
                {t('entity-event.save-to-cal')}
            </IconButton>
        </DropdownButton>
    )
}

export default AddToCalendar
